module.exports = __webpack_public_path__ + "img/1F494.66e3aee7.svg";